<template>
  <div>
         <el-row :gutter="10">
           <el-col :span="6">
              <el-row align="middle" type="flex" :gutter="1">
                <el-col :span="8">
                  <el-input
                    clearable
                    v-model="commissionItemObject.priceStart"
                    placeholder="请输入正整数"
                    onKeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))"
                  ></el-input
                ></el-col>
                <el-col :span="3">元 ~ </el-col>
                <el-col :span="8">
                  <el-input
                    clearable
                    v-model="commissionItemObject.priceEnd"
                    placeholder="请输入正整数"
                    onKeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))"
                  ></el-input>
                </el-col>
                <el-col :span="4">元(含)</el-col>
              </el-row>
           </el-col>
           <el-col :span="4">
              <el-row align="middle" type="flex" :gutter="1">
                <el-col :span="10"> <el-select
                v-model="commissionItemObject.commissionType"
              >
                <el-option
                  v-for="item in commissionTypeList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select></el-col>
                 <el-col :span="14">
                  <el-input clearable v-model="commissionItemObject.commission"  :placeholder="commissionItemObject.commissionType==1?'请输入小数':'请输入正数'" ></el-input>
                 </el-col>
              </el-row>
           </el-col>
           <el-col :span="4">
                 <el-row align="middle" type="flex" :gutter="1">
                <el-col :span="10"> <el-select
                v-model="commissionItemObject.employeeRedType"
              >
                <el-option
                  v-for="item in commissionTypeList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select></el-col>
                 <el-col :span="14">
                  <el-input clearable v-model="commissionItemObject.employeeRedPackage"  :placeholder="commissionItemObject.employeeRedType==1?'请输入小数':'请输入正数'" ></el-input>
                 </el-col>
              </el-row>
           </el-col>
           <el-col :span="4">
            <el-row align="middle" type="flex" :gutter="1">
                <el-col :span="10"> <el-select
                v-model="commissionItemObject.redType"
              >
                <el-option
                  v-for="item in commissionTypeList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select></el-col>
                 <el-col :span="16">
                  <el-input clearable v-model="commissionItemObject.redPackage"  :placeholder="commissionItemObject.redType==1?'请输入小数':'请输入正数'" ></el-input>
                 </el-col>
              </el-row>
           </el-col>
            <el-col :span="4">
            <el-row align="middle" type="flex" :gutter="1">
                <el-col :span="10"> <el-select
                v-model="commissionItemObject.mainPersonType"
              >
                <el-option
                  v-for="item in commissionTypeList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select></el-col>
                 <el-col :span="16">
                  <el-input clearable v-model="commissionItemObject.mainPersonCommission"  :placeholder="commissionItemObject.mainPersonType==1?'请输入小数':'请输入正数'" ></el-input>
                 </el-col>
              </el-row>
           </el-col>
           <el-col :span="1">
            <el-button
                  style="marginLeft:5px"
                  icon="el-icon-delete"
                  @click="deleteEvalItem()"
                ></el-button>
           </el-col>
         </el-row>
  </div>
</template>

<script>
export default {
  name: "commissionItem",
  components: {},
  props: [
    "commissionItemObject",
    "itemIndex",
  ],
  data() {
    return {
      editProfitCostForm:{},
      commissionTypeList:[{id:1,name:'比列'},{id:2,name:'固定金额'}],
    };
  },
  watch: {
  },
  computed: {},
  methods: {
    deleteEvalItem(){
       this.$emit(
        "deleteCommissionItem",
        this.$props.itemIndex
      );
    },
  },
  created() {},
  mounted() {
  },
};
</script>
<style lang="less" scoped></style>
